import { render, staticRenderFns } from "./RemainingFundsUsage.vue?vue&type=template&id=afe01c64&"
import script from "./RemainingFundsUsage.vue?vue&type=script&lang=ts&"
export * from "./RemainingFundsUsage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports